import { useState } from 'react';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    const formData = new FormData(formEl);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      formEl.reset();
      return;
    }

    try {
      const submitAddr = 'http://pedionline.com/';
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          urlEncoded.append(key, String(value));
        }
      });

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });

      const responseText = await response.text();
      let serverMsg = '';
      let isOk = false;
      try {
        const parsed = JSON.parse(responseText);
        isOk = response.ok && parsed?.code === 'OK';
        serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
      } catch {
        serverMsg = responseText;
      }

      if (isOk) {
        setStatus('success');
        formEl.reset();
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50" id="contact">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            <strong className="text-primary-500">联系</strong>我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            有任何问题或建议？欢迎随时与我们联系
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 max-w-4xl mx-auto">
          <div className="space-y-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">hello@pedionline.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 flex-shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">微信公众号</h3>
                <p className="text-sm text-foreground-500">韩漫屋官方</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-600 flex-shrink-0">
                <i className="ri-weibo-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">新浪微博</h3>
                <p className="text-sm text-foreground-500">@韩漫屋官方微博</p>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <form
              id="contact-form"
             
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <div>
                <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">
                  姓名
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-md focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">
                  邮箱
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-md focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">
                  留言
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-md focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言（不超过500字）"
                ></textarea>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute opacity-0 pointer-events-none"
                style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
              />
              <button
                type="submit"
                className="w-full px-6 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                发送留言
              </button>

              {status === 'success' && (
                <p className="text-sm text-primary-500 text-center mt-3">留言已发送！感谢您的反馈。</p>
              )}
              {status === 'error' && (
                <p className="text-sm text-red-500 text-center mt-3">{errorMsg}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}